import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DownloadableFileSet } from "../../interfaces/general/downloadable-file";
import { ExceptionsService } from "../../services/utelize/general/exceptions-service";

@Component({
  selector: 'app-page-comp-download-box',
  templateUrl: './page-comp-download-box.component.html',
  styleUrls: ['./page-comp-download-box.component.scss']
})

export class PageCompDownloadBoxComponent implements OnInit {
  
  @Input() downloadableFileSet: DownloadableFileSet | undefined;
    
  @Output() fileDownloadedEvent: EventEmitter<string>=new EventEmitter<string>();
  @Output() errorEvent         : EventEmitter<string>=new EventEmitter<string>();
  
  constructor(
    private exceptionsService: ExceptionsService
  ) {
    
  }

  public ngOnInit(): void {
    try {
      if (this.downloadableFileSet==undefined) {
        throw new Error("PageCompDownloadBoxComponent.DownloadableFile is undefined")
      }

      this.downloadableFileSet.webTitle=this.downloadableFileSet.webTitle.replaceAll("\n", "<br>")
      this.downloadableFileSet.webText =this.downloadableFileSet.webText.replaceAll("\n", "<br>")
    }
    catch(e) {
      this.errorEvent.emit((<Error>e).message);
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onImageLoad(img: HTMLImageElement) {
    try {
      const halfHeight=img.clientHeight/2;
      const textBlock =document.getElementById('textBlock');

      if (textBlock) {
        textBlock.style.height=`${halfHeight}px`;
      }
    }
    catch(e) {
      this.errorEvent.emit((<Error>e).message);
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public downloadFile(): void {
    try {
      const base64Content =this.downloadableFileSet!.fileDownload!.fileContents;
      const byteCharacters=atob(base64Content);
      const byteNumbers   =new Array(byteCharacters.length);

      for (let i=0; i<byteCharacters.length; i++) {
        byteNumbers[i]=byteCharacters.charCodeAt(i);
      }
      
      const byteArray=new Uint8Array(byteNumbers);
      const blob     =new Blob([byteArray], { type: this.downloadableFileSet!.contentType });
      const link     =document.createElement('a');
      link.href      =window.URL.createObjectURL(blob);
      link.download  =this.downloadableFileSet!.filename!;

      link.click();
      window.URL.revokeObjectURL(link.href);

      this.fileDownloadedEvent.emit(this.downloadableFileSet!.filename);
    }
    catch(e) {
      this.errorEvent.emit((<Error>e).message);
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
